import { useNavigate } from 'react-router-dom'

import {
  ContactFragment,
  CreateProjectDocument,
  CreateProjectMutation,
  CreateProjectMutationVariables,
  ProjectsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { CreateProjectModal } from 'modules/project_management/components/modals/CreateProjectModal'

const CREATE_PROJECT_MODAL_SOURCE = 'sales_contact_details_projects_page'

interface Props {
  client: ContactFragment
  onClose: () => void
  onSuccess: () => void
}

export const CreateWizard = ({ client, onClose, onSuccess }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const [create] = useMutation(CreateProjectDocument, {
    extractorFn: (data: CreateProjectMutation) =>
      data.projectManagementMutations.createProjectmanagementProject,
  })

  const createProject = (dto: CreateProjectMutationVariables) => {
    return create({
      variables: dto,
      awaitRefetchQueries: true,
      refetchQueries: [ProjectsDataCollectionDocument],
    })
  }

  useEffect(() => {
    track(trackingEvents.projectManagement.projects.createProjectModal.open, {
      source: CREATE_PROJECT_MODAL_SOURCE,
    })
  }, [])

  return (
    <CreateProjectModal
      isOpen
      onClose={onClose}
      create={createProject}
      clientId={client.id}
      onSuccess={(projectId) => {
        track(trackingEvents.projectManagement.projects.createProjectModal.submit, {
          source: CREATE_PROJECT_MODAL_SOURCE,
        })
        onSuccess()
        navigate(navigation.projects.id.details.settings.fullPath({ id: projectId }))
      }}
    />
  )
}
